import ITask from './ITask';
import Game from '../../Game';
import { UIActions } from '../../State/UI/UIActions';
import { delay } from './TaskQueue';
import { PopupID } from '../../State/UI/PopupID';
import System from 'System/System';

interface PopupTaskParams {
    popup?: PopupID;
    meta?: any;
    waitOnGamePaused?: boolean;
    [key: string]: any;
}
export default class PopupTask implements ITask<any> {
    private readonly taskData: PopupTaskParams;
    private readonly system: System;
    private cancelled: boolean = false;

    constructor(system: System, params: PopupTaskParams) {
        this.taskData = { ...params };
        this.system = system;
    }

    public getPopupID(): PopupID {
        return this.taskData.popup;
    }

    public cancel(): void {
        this.cancelled = true;
    }

    public *execute(): IterableIterator<any> {
        yield* this.yieldIfNeeded();
        yield* delay(this.taskData.delay || 0);

        if (this.cancelled) return;

        UIActions.showPopup(
            this.taskData.popup,
            // @ts-ignore
            this.taskData.meta
        );

        yield* this.yieldIfNeeded();
    }

    private *yieldIfNeeded(): IterableIterator<any> {
        let state = Game.store.getState();
        while (
            state.UIState.popupID != null ||
            (this.taskData.waitOnGamePaused && state.gamePaused) ||
            (this.taskData.waitForTasks && this.system.taskQueue.isRunning())
        ) {
            yield* delay(10);
            state = Game.store.getState();
        }
    }
}
